import styled from "styled-components";
import { Wrapper } from "AppReact";

const template = styled.div`
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  padding: 0px 16px 16px 16px;

  @media only screen and (min-width: 768px) {
    align-items: center;
  }
`;

export default Wrapper(template)